"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExpandElement = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Creates a component that displays the expand/adornment
 * for the search bar results
 *
 * @param {object} props
 * @returns JSX.Element
 */
var ExpandElement = function ExpandElement(props) {
  var text = props.text,
    classes = props.classes,
    iconSrc = props.iconSrc;
  var src = iconSrc || 'https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/bento/images/icons/svgs/EnterIcon.svg';
  return /*#__PURE__*/_react.default.createElement("div", null, text, ' ', /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
    className: classes.enterIcon,
    src: src,
    alt: "adornment icon"
  })));
};
exports.ExpandElement = ExpandElement;
var _default = ExpandElement;
exports.default = _default;